import React from "react";
import { Modal, Button, Alert } from "react-bootstrap";

export default function ModalConfirmar({ show, titulo = "Confirmar", mensaje, textoConfirmar = "Eliminar", error, onConfirmar, onCancelar }) {
  return (
    <Modal show={show} onHide={onCancelar} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>{titulo}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger" className="py-2">{error}</Alert>}
        {mensaje}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancelar}>Cancelar</Button>
        <Button variant="danger" onClick={onConfirmar}>{textoConfirmar}</Button>
      </Modal.Footer>
    </Modal>
  );
}
